<template>
  <gg-card>
    <gg-card-header>
      Account Information
      <template v-if="editable">
        <!-- Editing profile -->
        <gg-btn @click="openEditDialog" depressed  tile color="primary" class="float-right">
          <span aria-hidden="true">Edit</span>
          <span class="visually-hidden text-lowercase">
            Account information edit button
          </span>
        </gg-btn>

        <edit-profile-form
          :modal-status="editDialog"
          @close="closeEditDialog"
        />
      </template>
    </gg-card-header>
    <gg-card-text class="pa-4">
      <v-list>
        <v-list-item class="pa-0">
          <v-list-item-content>
            <v-list-item-subtitle>Name</v-list-item-subtitle>
            <v-list-item-title v-html="name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="pa-0">
          <v-list-item-content>
            <v-list-item-subtitle>Address</v-list-item-subtitle>
            <v-list-item-title>{{ SessionProfile.address1 }} {{ SessionProfile.address2 }}</v-list-item-title>
            <v-list-item-title>{{ SessionProfile.city }}, {{ SessionProfile.state }} {{ SessionProfile.postcode }}</v-list-item-title>
            <v-list-item-title>{{ SessionProfile.country }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="pa-0">
          <v-list-item-content>
            <v-list-item-subtitle>Email</v-list-item-subtitle>
            <v-list-item-title>
              {{ SessionProfile.email }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="pa-0">
          <v-list-item-content>
            <v-list-item-subtitle>Phone number</v-list-item-subtitle>
            <v-list-item-title>
              {{ SessionProfile.phonenumber }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters } from 'vuex'
import EditProfileForm from '@/components/Profile/EditProfileForm'

export default {
  name: 'ProfileCard',
  props: {
    editable: {
      type: Boolean,
      default: true
    },
  },
  components: {
    EditProfileForm,
  },
  data: () => ({
    editDialog: false,
    loading: false
  }),
  computed: {
    ...mapGetters(['SessionProfile']),
    name () {
      return `${this.SessionProfile.firstname} ${this.SessionProfile.lastname}`
    }
  },
  methods: {
    openEditDialog () {
      this.editDialog = true
    },
    closeEditDialog () {
      this.editDialog = false
    }
  },
}
</script>
